// Blog Landing Page
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Filter from '../filter/Filter';
import Pagination from '../pagination/Pagination';
import Lazyload from '../../modules/lazyload';

class BlogArticles extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pageOfItems: [],
    };

    this.onChangePage = this.onChangePage.bind(this);
  }

  componentDidMount() {
    Lazyload();
  }

  componentDidUpdate() {
    Lazyload();
    window.scrollTo(0, 0);
  }

  onChangePage(pageOfItems) {
    // update state with new page of items
    this.setState({ pageOfItems });
  }

  render() {
    const {
      filterToggle,
      filterToggleClick,
      filters,
      selectedFilters,
      articleItems,
      buttonClick,
      closeAllDropdowns,
      filterClick,
      removeFilter,
      clearFilters,
    } = this.props;

    return (
      <div className="article-container">
        <section className="filter article-category-filter">
          <div className="container">
            <div className="row">
              <div className="col-12 col-sm-3 col-md-2">
                <h5 className="filter-heading">Filter Articles</h5>
              </div>
              <div className="col-12 col-sm-9 col-md-10">
                <div className={`filter-toggle${filterToggle ? ' toggled' : ''}`}>
                  <Filter
                    filters={filters}
                    selectedFilters={selectedFilters}
                    buttonClick={buttonClick}
                    closeAllDropdowns={closeAllDropdowns}
                    filterClick={filterClick}
                    removeFilter={removeFilter}
                    clearFilters={clearFilters}
                  />
                  <button className={`filter-toggle-button${filterToggle ? ' toggled-button-close' : ''}`} type="button" onClick={() => filterToggleClick()}>Apply</button>
                </div>
                <button className={`filter-toggle-button${filterToggle ? ' toggled-button' : ''}`} type="button" onClick={() => filterToggleClick()}>Filter Articles</button>
              </div>
            </div>
          </div>
        </section>
        <section className="article-list">
          <div className="container">
            {(articleItems.length > 0)
            ? (
              <div className="article-wrapper">
                <div className="row all-articles">
                  {this.state.pageOfItems.map(article => (
                    <div key={article.id} className="article-preview col-12 col-sm-6 col-lg-4">
                      <a className="article-preview-link" href={article.articleLink}>
                        <div className="article-primary-image-container">
                          <img className="article-primary-image lazy" data-src={article.primaryImage} alt={article.primaryImageAltTag} />
                          <div className="loader-placeholder">
                            <svg id="loading" className="loading" data-name="loading" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300">
                              <title>Loading</title>
                              <path className="loading-path" d="M250,149A100,100,0,1,0,150,250c1.68,0,3.34-.06,5-.14V212.29c-1.65.14-3.32.21-5,.21A62.5,62.5,0,1,1,212.47,149H200l30,30,30-30Z" />
                            </svg>
                          </div>
                        </div>
                        <h5 className="article-category">
                          {article.articleCategories.map((category, index) => (
                            <span className="article-category-text">{category.name}{(index === article.articleCategories.length - 1 ? '' : ', ')}</span>
                          ))}
                        </h5>
                        <h3 className="article-title">{article.articleTitle}</h3>
                        <p className="dotted-link"><span>{this.props.articlesListLinkText}</span> →</p>
                      </a>
                    </div>
                  ))}
                  <Pagination items={this.props.articleItems} onChangePage={this.onChangePage} />
                </div>
              </div>
            ) : (
              <div className="results-message-container">
                <p>{this.props.noResultsMessage}</p>
              </div>
            )}
          </div>
        </section>
      </div>
    );
  }
}

BlogArticles.propTypes = {
  articleItems: PropTypes.string,
  noResultsMessage: PropTypes.string,
  articlesListLinkText: PropTypes.string,
  filterToggle: PropTypes.bool,
  filterToggleClick: PropTypes.func.isRequired,
  buttonClick: PropTypes.func.isRequired,
  closeAllDropdowns: PropTypes.func.isRequired,
  filterClick: PropTypes.func.isRequired,
  removeFilter: PropTypes.func.isRequired,
  clearFilters: PropTypes.func.isRequired,
  filters: PropTypes.shape(PropTypes.object),
  selectedFilters: PropTypes.arrayOf(PropTypes.string),
};

export default BlogArticles;
